import { useEffect, useRef } from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { motion } from "framer-motion";
import { brand } from "@/content/site";
import { WhatsAppIcon } from "@/components/common/WhatsAppIcon";

// Confirmation shown after submit. WhatsApp link carries the full enquiry, pre-filled.
const COPY = {
  done: { title: "Thank you. Enquiry received.", body: "Your details are with SPC. Send the same enquiry on WhatsApp so our team can reply to you directly." },
  offline: { title: "Almost there.", body: "We could not save your enquiry online just now, but you can still send it to SPC directly on WhatsApp." },
};

export const FormSuccess = ({ reference, waLink, mode, onReset, idPrefix }) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, []);
  return (
  <motion.div
    ref={ref}
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    className="border border-accent/40 bg-accent-soft p-8 sm:p-10"
    role="status"
    aria-live="polite"
    data-testid={`${idPrefix}-success`}
  >
    {mode === "offline" ? <AlertTriangle className="h-8 w-8 text-accent" /> : <CheckCircle2 className="h-8 w-8 text-accent" />}
    <h3 className="mt-5 font-display text-3xl font-semibold tracking-[-0.03em] text-ink">{COPY[mode].title}</h3>
    <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-ink/85">{COPY[mode].body}</p>
    {reference && (
      <p className="mt-4 font-mono text-[13px] text-ink" data-testid={`${idPrefix}-reference`}>
        Reference: {reference}
      </p>
    )}
    <div className="mt-8 flex flex-wrap items-center gap-3">
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2.5 rounded-none bg-accent px-6 py-3.5 text-[15px] font-medium text-accent-ink transition-transform duration-300 hover:-translate-y-0.5"
        data-testid={`${idPrefix}-whatsapp-button`}
      >
        <WhatsAppIcon /> Send on WhatsApp
      </a>
      <button type="button" onClick={onReset} className="rounded-none px-5 py-3.5 text-[15px] text-ink underline-offset-4 hover:underline" data-testid={`${idPrefix}-reset-button`}>
        Send another enquiry
      </button>
    </div>
    <p className="mt-6 text-[13px] text-muted">
      Prefer email? Write to{" "}
      <a className="text-accent underline-offset-4 hover:underline" href={`mailto:${brand.email}`}>
        {brand.email}
      </a>
    </p>
  </motion.div>
  );
};
